module.exports = __webpack_public_path__ + "img/open-folder-focused.b8e8727b.svg";